import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TextDirectionDirective } from './directives/text-direction.directive';

const exportDirectives = [TextDirectionDirective];

@NgModule({
  imports: [CommonModule],
  exports: [CommonModule, ...exportDirectives],
  declarations: [...exportDirectives],
})
export class SharedModule {}
